import { Popconfirm, Space, Tag, Tooltip } from "antd"
import { Button } from "src/components/actions/button"
import { PencilSvg, TrashSvg } from "src/components/Svg"

export function getColumns(onEdit, onDelete) {
  return [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      sorter: (a, b) => a.id - b.id,
      defaultSortOrder: "ascend",
    },
    {
      title: "Название",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Slug",
      dataIndex: "slug",
      key: "slug",
    },
    {
      title: "Разрешения",
      dataIndex: "permissionNames",
      key: "permissionNames",
      render: (names) =>
        names?.map((name, index) => (
          <Tag key={index} style={{ marginBottom: 4 }}>
            {name}
          </Tag>
        )),
    },
    ...(onEdit || onDelete ? [{
      title: "Действие",
      key: "action",
      render: (_, record) => (
        <Space size="small">
          {onEdit && (
            <Tooltip placement="top" title="Редактировать" mouseLeaveDelay={0}>
              <Button size="small" type="link" onClick={() => onEdit(record.id)}>
                <PencilSvg />
              </Button>
            </Tooltip>
          )}
          {onDelete && (
            <Tooltip placement="top" title="Удалить" mouseLeaveDelay={0}>
              <Popconfirm
                placement="left"
                title="Действительно хотите удалить?"
                onConfirm={() => onDelete(record.id)}
                onCancel={stopPropagation}
              >
                <Button size="small" type="link" onClick={stopPropagation}>
                  <TrashSvg />
                </Button>
              </Popconfirm>
            </Tooltip>
          )}
        </Space>
      ),
    }] : []),
  ]
}

const stopPropagation = (e) => {
  e?.stopPropagation()
}
